<template>
  <BottomStackItem layer="notifications">
    <NotificationCard
      v-if="connectionStore.shouldShowWarning"
      type="warn"
      message="You’re offline. Check your connection, then retry."
      :actions="[{ label: 'Retry', onClick: connectionStore.retry }]"
      dismiss-label="Dismiss realtime connection warning"
      @dismiss="connectionStore.dismissWarning" />
  </BottomStackItem>
</template>

<script setup lang="ts">
import BottomStackItem from '@dashboard/components/common/BottomStackItem.vue'
import NotificationCard from '@dashboard/components/common/NotificationCard.vue'
import { useConnectionStore } from '@dashboard/stores/connectionStore'

const connectionStore = useConnectionStore()
</script>
